/**
 * Lo que hay que leer antes de aplicar un paquete por tipo de negocio en «Qué sabe hacer».
 * El paquete REEMPLAZA lo encendido: el 7-oct un clic en «personal» dejó el panel de
 * Richard sin Seguimientos, Clientes, Proyectos ni agente. PURO.
 */
export function preguntaDelPaquete(
  tipo: string,
  catalogo: Array<{ id: string; nombre: string }>,
  encendidos: ReadonlySet<string>,
  delPaquete: string[],
): string {
  const seApagan = catalogo.filter((m) => encendidos.has(m.id) && !delPaquete.includes(m.id)).map((m) => m.nombre);
  const efecto = seApagan.length ? `Se apagan: ${seApagan.join(', ')}.` : 'No apaga nada de lo que hay encendido.';
  return `El paquete «${tipo}» reemplaza lo que está encendido ahora. ${efecto} ¿Aplicarlo?`;
}
